import { useGetFeedListWeb } from "./model";
import { useEffect, useState } from "react";
import { FeedClaimBottomSheet } from "../feedClaimBottomSheet";
import { useNavigate } from "react-router-dom";
import { TextBtn } from "../../../../shared";
import FeedCard from "../feedCard";
import { NotMyfeedAndCommentBottomSheet } from "../notMyfeedAndCommentBottomSheet";
import MyFeedBottomSheet from "../myFeedBottomSheet";

interface IProps {
    onToastChange?: Function
    setInitLoading?: Function
}

const RecommendFeed = ({ onToastChange, setInitLoading }: IProps) => {
    const navigate = useNavigate();
    const { data: feedList = [], isLoading, isSuccess } = useGetFeedListWeb();
    const [notMyBottomSheetOpen, setNotMyBottomSheetOpen] = useState<boolean>(false);
    const [isOpenFeedClaimModal, setIsOpenFeedClaimModal] = useState<boolean>(false);
    const [feedId, setFeedId] = useState<number | undefined>(undefined);
    const [selectedFeed, setSelectedFeed] = useState<IGetMyFeedWebResponse>();
    const [isMyBottomSheet, setIsMyBottomSheet] = useState<boolean>(false);

    useEffect(() => {
        if (isSuccess) {
            setInitLoading?.(false)
        }

    }, [isSuccess])

    return <div>
        {feedList.length === 0
            ? <div style={{ textAlign: 'center', paddingTop: '17.67vh' }}>
                <div className="body/b2 secondary/s600" style={{ marginBottom: '8px' }}>
                    아직 게시된 글이 없습니다.<br />
                    커뮤니티 첫 글을 써보세요!
                </div>
                <TextBtn onClick={() => navigate('/create/feed')} classNames={{ children: 'secondary/s800' }} styles={{ container: { padding: 'var(--space4)' }, children: { textDecorationColor: 'var(--secondarys800)' } }} type='underline' icon={false}>글쓰기</TextBtn>
            </div>
            : feedList.map(feed => <FeedCard key={feed.id} feed={feed} setSelectedFeed={(e: Omit<IGetMyFeedWebResponse, 'isShow' | 'isPrivate'> & Partial<Pick<IGetMyFeedWebResponse, 'isShow' | 'isPrivate'>>) => { setSelectedFeed({ ...e, isShow: true, isPrivate: false }); setFeedId(e.id) }} setIsShowBottomSheet={() => feed.isMyFeed ? setIsMyBottomSheet(true) : setNotMyBottomSheetOpen(true)} isLoading={isLoading} isMyFeed={false} />)}


        <NotMyfeedAndCommentBottomSheet isOpen={notMyBottomSheetOpen} setIsOpen={setNotMyBottomSheetOpen} onClick={(q: number) => q === 1 && setIsOpenFeedClaimModal(true)} />
        <FeedClaimBottomSheet
            feedId={feedId}
            isFeedClaim
            isOpen={isOpenFeedClaimModal}
            setIsOpen={setIsOpenFeedClaimModal}
        />
        <MyFeedBottomSheet selectedFeed={selectedFeed} isShowBottomSheet={isMyBottomSheet} setIsShowBottomSheet={setIsMyBottomSheet} onToastChange={onToastChange} />
    </div>
}

export default RecommendFeed